import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';


export default function initTicketsBlocks() {
  if (window.ticketsBlocksInitialized) return;
  window.ticketsBlocksInitialized = true;

  const blocks = document.querySelectorAll(".component.tickets-block");
  if (!blocks.length) return;

  const mq = window.matchMedia("(max-width: 991px)"); // Bootstrap < lg
  const instances = new Map();

  function enable(block) {
    if (instances.get(block)) return;

    const containerEl = block.querySelector(".wrap");
    const wrapperEl = block.querySelector(".wrapper");
    const prevEl = block.querySelector(".swiper-button-prev");
    const nextEl = block.querySelector(".swiper-button-next");

    if (!containerEl || !wrapperEl) return;

    const swiper = new Swiper(containerEl, {
      modules: [Navigation],
      wrapperClass: "wrapper",
      slideClass: "tickets__item",

      slidesPerView: "auto",
      spaceBetween: 16,
      speed: 450,
      resistanceRatio: 0.85,
      watchOverflow: true,

      navigation: {
        prevEl,
        nextEl,
        disabledClass: "swiper-button-disabled"
      },

      // Accessibilité correcte
      a11y: { enabled: true },
    });

    instances.set(block, swiper);
  }

  function disable(block) {
    const swiper = instances.get(block);
    if (!swiper) return;
    swiper.destroy(true, true);
    instances.delete(block);
  }

  function refresh() {
    blocks.forEach((block) => {
      if (mq.matches) enable(block);
      else disable(block);
    });
  }

  refresh();
  mq.addEventListener("change", refresh);

  window.addEventListener("orientationchange", () => {
    setTimeout(() => blocks.forEach((b) => instances.get(b)?.update()), 250);
  });
}